import moment from 'moment';

import Row from 'components/UIKit/Flex/Row';
import Column from 'components/UIKit/Flex/Column';
import FlipCard from 'components/UIKit/Card/FlipCard';
import { Donut, QCDonut } from 'components/charts/Donut';
import { Tooltip } from 'components/UIKit/Tooltip';

import {
  ClinicalIcon,
  CaseIcon,
  BiospecimenIcon,
  UploadIcon,
  HelpIcon,
} from 'components/icons';
import {
  PINK, PURPLE, SECONDARY_BLUE, TEAL,
} from 'style/colors';

import { DataFilesManifestsDownloadContainer } from 'containers/DownloadContainers';

const styles = {
  centered: {
    justifyContent: 'center',
  },
};

const DonutRow = ({
  params,
  style,
  widgets,
}) => (
  <Column style={style}>
    <Row data-testid="project-overview-card-row" >
      <FlipCard
        data-testid="card-qc-errors"
        title="QC Errors"
        titleStyle={styles.centered}
        isFetching={widgets.qcErrors.isFetching}
        tooltip={{
          text: 'This chart shows the number of critical errors and warnings in the current unsubmitted data. CRITICAL errors are displayed as red and WARNING level errors are displayed as orange.',
          size: { height: 'auto', width: 250 },
        }}
        MainComponent={(
          <Column>
            <QCDonut
              criticalData={widgets.qcErrors.data.CRITICAL}
              warningData={widgets.qcErrors.data.WARNING}
              isFetching={widgets.qcErrors.isFetching}
              type="Errors"
              params={params}
              path="qc"
              />
          </Column>
        )}
        style={{ padding: '0' }}
        />
      <FlipCard
        data-testid="card-cases-with-clinical"
        title="Cases with Clinical"
        titleStyle={styles.centered}
        isFetching={widgets.casesWithClinical.isFetching}
        tooltip={{
          text: 'This chart shows the number of registered cases in the project that have clinical data.',
        }}
        MainComponent={(
          <Column>
            <Donut
              withData={widgets.casesWithClinical.data.count}
              withoutData={widgets.casesWithClinical.data.caseCount - widgets.casesWithClinical.data.count}
              isFetching={widgets.casesWithClinical.isFetching}
              type="Cases"
              colour={PINK}
              icon={ClinicalIcon}
              />
          </Column>
        )}
        style={{ padding: '0' }}
        />
      <FlipCard
        data-testid="card-cases-with-biospecimen"
        title="Cases with Biospecimen"
        titleStyle={styles.centered}
        isFetching={widgets.casesWithBiospecimen.isFetching}
        tooltip={{
          text: 'This chart shows the number of registered cases in the project that have biospecimen data.',
        }}
        MainComponent={(
          <Column>
            <Donut
              withData={widgets.casesWithBiospecimen.data.count}
              withoutData={widgets.casesWithBiospecimen.data.caseCount - widgets.casesWithBiospecimen.data.count}
              type="Cases"
              isFetching={widgets.casesWithBiospecimen.isFetching}
              colour={TEAL}
              icon={BiospecimenIcon}
              />
          </Column>
        )}
        style={{ padding: '0' }}
        />
      <FlipCard
        data-testid="card-cases-with-submittable-data-files"
        title="Cases with Submittable Data Files"
        titleStyle={styles.centered}
        isFetching={widgets.casesWithData.isFetching}
        tooltip={{
          text: 'This chart shows the number of registered cases in the project that have Submittable Data Files.',
        }}
        MainComponent={(
          <Column>
            <Donut
              withData={widgets.casesWithData.data.count}
              withoutData={widgets.casesWithData.data.caseCount - widgets.casesWithData.data.count}
              isFetching={widgets.casesWithData.isFetching}
              type="Cases"
              colour={SECONDARY_BLUE}
              icon={CaseIcon}
              />
          </Column>
        )}
        style={{ padding: '0' }}
        />
      <FlipCard
        data-testid="card-submittable-data-files"
        title="Submittable Data Files"
        titleStyle={styles.centered}
        isFetching={widgets.filesUploaded.isFetching}
        tooltip={{
          text: 'This chart shows the number of registered submittable data files that have been successfully uploaded.  Totals do not include files that have been submitted for harmonization.',
          size: { height: 'auto', width: 250 },
        }}
        MainComponent={(
          <Column>
            <Donut
              withoutData={widgets.filesUploaded.data.count - widgets.filesUploaded.data.validatedIds.length}
              withData={widgets.filesUploaded.data.validatedIds.length}
              isFetching={widgets.filesUploaded.isFetching}
              type="Files"
              colour={PURPLE}
              icon={UploadIcon}
              />
          </Column>
        )}
        style={{ padding: '0' }}
        BottomComponent={(
          <Row data-testid="button-download-manifest">
            <DataFilesManifestsDownloadContainer
              dataFilesIds={widgets.filesUploaded.data.manifestIds}
              filename={`manifest_validated_files_${moment().format('YYYYMMDDHHmm')}.yml`}
              >
              Download Manifest
            </DataFilesManifestsDownloadContainer>
            <Tooltip
              Component={(
                <Row>
                  Download manifest for the validated files that have not been
                  uploaded through the GDC Data Transfer Tool.
                </Row>
              )}
              >
              <Row><HelpIcon style={{ fontSize: '1.3rem', color: '#2a72a5' }} /></Row>
            </Tooltip>
          </Row>
        )}
        />
    </Row>
  </Column>
);

export default DonutRow;
